import "./App.css";
import Headers from "./comp/Headers";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import ScrollSections from "./Pages/ScrollSections";
import Contact2 from "./Pages/Contact2";

function App() {
  return (
    <Router>
            <Headers />
     
 
      <Routes>
      <Route path="/" element={ <ScrollSections/>} />
          <Route path="/contact" element={<Contact2 />} />
        </Routes>
  
    </Router>
  );
}

export default App;
